import { AxiosInstance } from "axios"
import { CompanyListResponse } from "services/sicalcApi/responses/companyListResponse"
import { CompanyResponse } from "services/sicalcApi/responses/companyResponse"
import { CreateCompanyRequest } from "services/sicalcApi/requests/createCompanyRequest"

export class CompanyApi {
  private sicalcClient: AxiosInstance

  constructor(sicalcClient: AxiosInstance) {
    this.sicalcClient = sicalcClient
  }

  /** Available without signing in */
  public async getAllWithoutUsers() {
    const url = `/api/v1/companies/without-users`
    const response = await this.sicalcClient.get<CompanyListResponse>(url)
    return response.data
  }

  public async create(request: CreateCompanyRequest) {
    const url = `/api/v1/companies`
    const response = await this.sicalcClient.post<CompanyResponse>(url, request)
    return response.data
  }
}
